import {AxiosResponse} from "axios/index";
import {$toRef} from "vue/macros";

export class AjaxHelperResponse{
    protected response:AxiosResponse|null = null;
    protected data_type:string|null = null;

    constructor(response:AxiosResponse|null = null, data_type:string|null = null) {
        this.response = response;
        this.data_type = data_type;
    }

    public getData(key: string | null = null): any {
        if (key !== null) {
            const keys = key.split('.');
            let data = this.response.data['data'];

            for (const key of keys) {
                if (data && typeof data === 'object' && key in data) {
                    data = data[key];
                } else {
                    data = null;
                    break;
                }
            }

            return data ?? null;
        }

        return this.response.data ?? null;
    }

    public getMessage():string|null{
        const message = this.getData('message');
        if(typeof message === 'string') {
            return message;
        }
        return null;
    }

    public getDataType(name:string|null = null) :string|boolean{
        if(name !== null){
            return this.data_type === name;
        }
        return this.data_type;
    }

    public isSuccess(){
        return this.response !== null && this.response.status === 200 &&
            (this.getData('success') === null || this.getData('success') === true || this.getData('success') === undefined);
    }
}
